import axios from "axios";
import axiosInstance from "../services/axiosInstance";
import axiosAdminPublicInstance from "../services/axiosAdminPublicInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchPaymentHistory = async (
  clientId,
  pageNumber,
  pageSize,
  sortOrder = "asc",
  sortBy = "DueDate"
) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_PAYMENT_HISTORY}/${clientId}?sortBy=${sortBy}&sortOrder=${sortOrder}&PageNumber=${pageNumber}&PageSize=${pageSize}`
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const updatePaymentDetailsAPI = async (clientId, paymentDetails) => {
  try {
    const response = await axiosInstance.post(
      `${Endpoints.UPDATE_PAYMENT_DETAILS}/${clientId}`,
      paymentDetails
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const pauseClientSubscriptionAPI = async ({
  clientId,
  resumeDate,
  coachId
}) => {
  const payload = {
    clientId,
    resumeDate,
    createdBy: coachId,
    updatedby: coachId,
  };
  try {
    const response = await axiosInstance.post(
      `${Endpoints.PAUSE_CLIENT_SUBSCRIPTION}`,
      payload
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const endClientSubscriptionAPI = async ({
  clientId,
  endImmediately,
  endAfterBilling,
  coachId,
}) => {
  const payload = {
    clientId,
    endImmediately,
    endAfterBilling,
    createdBy: coachId,
    updatedby: coachId,
  };
  try {
    const response = await axiosInstance.post(
      `${Endpoints.END_CLIENT_SUBSCRIPTION}`,
      payload
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const updatePaymentDetailsRetryAPI = async ({
  paymentId,
}) => {
  try {
    // Step 1: Get admin token
    const tokenParams = new URLSearchParams();
    tokenParams.append("username", "admin");
    tokenParams.append("password", "admin");
    tokenParams.append("grant_type", "password");

    const tokenResponse = await axios.post(
      Endpoints.ADMIN_TOKEN_ENDPOINT,
      tokenParams,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    const token = tokenResponse.data?.access_token;

    // Step 2: Call retry payment with the token
    const response = await axiosAdminPublicInstance.get(
      `${Endpoints.RETRY_PAYMENT}?PaymentId=${paymentId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};
